import React, { Component } from 'react';


import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

// Redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// actions
import { apiError, checkLogin, resetLoginState, verify_admin } from '../../store/actions';

// import images
import { Alert, Checkbox, FormControlLabel, InputAdornment, Stack, TextField } from '@mui/material';
import logolight from "../../assets/images/Aspeed_Logo.png";
import withRouter from '../../components/Common/withRouter';
import LoadingDialog from '../../components/Common/LoadingDialog';
import CustomButton from '../../components/Form/CustomButton';

class Login extends Component {

    constructor(props) {
        super(props);
        this.props.resetLoginState()
        this.state = { username: "", password: "", loading: false, rememberMe: false, width: window.innerWidth }
        // this.state = { username: "superadmin@app.com", password: "password", loading: false, rememberMe: false }
        // this.state = { username: "admin@themesdesign.in", password: "123456" }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        this.props.resetLoginState()
        this.setState({ loading: true });
        localStorage.setItem("remember", this.state.rememberMe);

        if (this.state.rememberMe) {
            localStorage.setItem("username", this.state.username);
        } else {
            localStorage.removeItem("username");
        }

        const values = {
            email: this.state.username,
            password: this.state.password
        }
        this.props.checkLogin(values, this.props.router.navigate, this.state.rememberMe);
        // this.setState({ loading: false });
    }
    async componentDidMount() {
        // this.props.apiError("");
        document.body.classList.add("auth-body-bg");
        if (localStorage.getItem("remember") === "true") {
            this.setState({ username: localStorage.getItem("username"), rememberMe: true });
        }
        this.handleResize = () => {
            this.setState({ width: window.innerWidth }); // Update state when window resizes
        };
        window.addEventListener("resize", this.handleResize);
        this.setState({ error: null }); // Assuming setError() sets an error state
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
        window.removeEventListener("resize", this.handleResize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.loginError && this.props.loginError) {
                this.setState({ loading: false });
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{ backgroundColor: '#F1F5F7' }}>
                    <LoadingDialog open={this.state.loading} />
                    <Container fluid className="p-0">
                        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '100vh' }} onKeyDown={(e) => {
                            if (e.key === "Enter") this.handleSubmit();
                        }}>
                            <div>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <img
                                        src={logolight}
                                        alt=""
                                        height="80"
                                        className=""
                                        style={{
                                            maxWidth: "70%",
                                            height: "auto",
                                        }}
                                    />
                                </div>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <Card
                                        className="p-3 mt-2 px-4"
                                        style={{
                                            borderRadius: 8,
                                            boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.1)",
                                            width: this.state.width < 768 ? '80vw' : '500px'
                                        }}
                                    >
                                        <CardBody>
                                            <div
                                                style={{
                                                    fontSize: 22,
                                                    fontFamily: "Manrope-SemiBold",
                                                    textAlign: "center",
                                                }}
                                            >
                                                Log in
                                            </div>
                                            <p className="text-muted text-center" style={{ fontSize: "14px" }}>
                                                Continue to Aspeed Ecommerce Management System
                                            </p>
                                            {this.props?.loginError && !(this.props.loginError?.code) ? <Alert severity="error" >{this.props.loginError}</Alert> : null}
                                            <div className=" mt-2">
                                                <div className=" mb-2">
                                                    <Stack flexDirection="column">
                                                        <Label htmlFor="username">Email</Label>
                                                        <TextField
                                                            required
                                                            value={this.state.username}
                                                            variant="outlined"
                                                            placeholder='Enter your email'
                                                            onChange={(e) => this.setState({ username: e.target.value })}
                                                            style={{ backgroundColor: 'white' }}
                                                        />
                                                    </Stack>
                                                </div>
                                                <div className=" mb-2">
                                                    <Stack flexDirection="column">
                                                        <Label htmlFor="userpassword">Password</Label>
                                                        <TextField
                                                            required
                                                            type='password'
                                                            value={this.state.password}
                                                            placeholder='Enter your password'
                                                            variant="outlined"
                                                            style={{ backgroundColor: 'white' }}
                                                            onChange={(e) => this.setState({ password: e.target.value })}
                                                        />
                                                    </Stack>
                                                </div>
                                                <div className="mt-3">
                                                    <FormControlLabel required
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.rememberMe}
                                                                value={this.state.rememberMe}
                                                                sx={{
                                                                    color: '#D0D0D0',
                                                                    '&.Mui-checked': {
                                                                        color: "var(--bs-theme-color)",
                                                                    },
                                                                    paddingBlock: 0
                                                                }}
                                                                onChange={(event) => this.setState({ rememberMe: !this.state.rememberMe })}
                                                            />
                                                        }
                                                        label={<span style={{ fontFamily: 'Manrope' }}>Remember me</span>}
                                                    />
                                                </div>
                                                <div className="mt-4 text-center">
                                                    <CustomButton
                                                        title={'Login'}
                                                        backgroundColor={'var(--bs-theme-color)'}
                                                        textColor={'white'}
                                                        width={'100%'}
                                                        borderRadius={8}
                                                        press={() => this.handleSubmit()}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <Link to="/forgot-password" className="text-muted clickable-text" style={{ color: '#282828' }}>Forgot your password?</Link>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { loginError } = state.Login;
    return { loginError };
}

export default withRouter(connect(mapStatetoProps, { checkLogin, apiError, resetLoginState })(Login));